// ============================================================================
// CASE COURT DETAIL SERVICE — ADR-0001
// ============================================================================

import { get, post } from '../client/axiosClient';
import { caseCourtDetailEndpoints } from '../endpoints/caseCourtDetail.endpoints';
import type { ApiResponse, ID } from '../types';
import type { CaseCourtDetail, SaveCaseCourtDetailRequest } from '../types/caseCourtDetail.types';

class CaseCourtDetailService {
  /** Returns the case's court detail, or null when none exists yet. */
  async getByCase(caseId: ID): Promise<ApiResponse<CaseCourtDetail | null>> {
    const response = await get<ApiResponse<CaseCourtDetail | null>>(
      caseCourtDetailEndpoints.byCase(caseId),
    );
    return response.data;
  }

  /** Upsert — inserts on first save, updates thereafter. */
  async save(data: SaveCaseCourtDetailRequest): Promise<ApiResponse<CaseCourtDetail>> {
    const response = await post<ApiResponse<CaseCourtDetail>>(
      caseCourtDetailEndpoints.save(),
      data,
    );
    return response.data;
  }
}

export const caseCourtDetailService = new CaseCourtDetailService();
export default caseCourtDetailService;
